<template>
	<div class="social-login">
		<div class="flex flex-col items-center justify-center">
			<div class="js-login-google m-1" :data-is-login="String(isLogin)"></div>

			<!-- /!\ Facebook-Attribute in camelCase, sonst funktioniert der Login nicht! -->
			<button
				type="button"
				class="o-btn js-login-facebook flex-center m-1 flex w-72 basis-10 justify-between rounded-3xl border border-solid border-[#dadce0] px-3 hover:border-[#d2e3fc] hover:bg-[rgba(66,133,244,.04)]"
				:facebookAction="facebookAction"
				:facebookInThirdPartyAppAuthAction="facebookInThirdPartyAppAuthAction"
				facebookUserInfoScope="email"
				:isrememberme="rememberMe"
				data-track-element="FacebookBtnClick"
				@click="_sendTracking($event)"
			>
				<UseSvg
					svg-file-name="logos"
					svg-id="social-facebook"
					class="svg-icon flex-icon social-icon pointer-events-none h-[18px] w-[18px]"
				/>
				<span class="pointer-events-none w-full text-center text-sm font-medium text-[#3c4043]">{{
					labels.facebook_button
				}}</span>
			</button>
		</div>

		<div v-if="$data.$_oauthErrorResponse" class="mt-4">
			<Error v-for="(error, i) in $data.$_oauthErrorResponse" :key="error + i">{{ error }}</Error>
		</div>
	</div>
</template>

<script>
import UseSvg from "@SharedVueComponents/Svg/UseSvg";
import { pushEvent } from "@/services/dataLayerLogin";
import labels from "../labels.json";

import OcmMessenger from "ocm_mercurius_messenger";
import { messengerPublicationTypes } from "@ocm/services/services.constants.js";

const contextPath = ocm.config.encodedContextPath;
const facebookAction = `${contextPath}/rest/auth/facebook/`;
const facebookInThirdPartyAppAuthAction = `${contextPath}/rest/authapp/facebook/`;

let facebookLoginSubscriberId;
let googleLoginSubscriberId;

// Schnittstellen / Beschreibung:
// ausgehende Events: OnOAuthError
// eingehende Funktions-Aufrufe ("public"): resetOAuthErrors
// Login-Funktionen über js-login-google und js-login-facebook

export default {
	components: {
		UseSvg,
	},
	props: {
		isLogin: { type: Boolean, required: true }, // nur für Tracking benötigt
	},
	data() {
		return {
			facebookAction,
			facebookInThirdPartyAppAuthAction,

			oauthErrorResponse: null,

			rememberMe: true,
			labels,
		};
	},
	mounted() {
		facebookLoginSubscriberId = OcmMessenger.subscribe(
			messengerPublicationTypes.FACEBOOK_LOGIN,
			this._handleOAuthErrors
		);
		googleLoginSubscriberId = OcmMessenger.subscribe(messengerPublicationTypes.GOOGLE_LOGIN, this._handleOAuthErrors);
	},
	beforeDestroy() {
		OcmMessenger.unsubscribe(facebookLoginSubscriberId);
		OcmMessenger.unsubscribe(googleLoginSubscriberId);
	},
	methods: {
		_handleOAuthErrors(publication) {
			if (!(publication.data && publication.data.type === "ERROR")) {
				return;
			}
			this.$emit("OnOAuthError");
			this.oauthErrorResponse = publication.data.detail;
		},
		resetOAuthErrors() {
			// "public"
			this.oauthErrorResponse = null;
		},
		_sendTracking(event) {
			const trackedElement = event?.currentTarget?.dataset?.trackElement;
			pushEvent(this.isLogin ? "LoginLayer" : "RegistrationLayer", trackedElement);
		},
	},
};
</script>
